module.exports = __webpack_public_path__ + "10da16e6.png";